<template>
  <div>
    <template v-if="canSeeGallery">
      <CSidebarNavTitle style="padding-right: 10px">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <span>{{ $gettext('Galleries') }}</span>
            <CIcon name="cipRefreshCw04" size="custom-size"
                   width="16" class="ml-2 rotating"
                   v-if="hasGlobalProcessingMedia"/>
          </div>
          <CLink @click="$emit('createGallery')" v-if="hasPerm('gallery.create')" class="p-0">
            <CIcon name="cip-plus" size="custom" :height="16" class="add-gallery"/>
          </CLink>
        </div>
      </CSidebarNavTitle>

      <draggable v-model="sortedGalleries" @end="updateGallerySorting" handle=".gallery-sort" ghost-class="ghost">
        <transition-group type="transition" :name="'flip-list'">
          <div v-for="gallery in sortedGalleries" :key="gallery.id">
            <sub-gallery-nav
              :gallery="gallery"
              :level="0"
              :is-last="false"
              :can-sort="sortedGalleries.length > 1 && canSort"
              :tab="tab"
              :pica-service-id="picaServiceId"
              @update-sorting="handleSubSorting"
            />
          </div>
        </transition-group>
      </draggable>
    </template>
    <template v-if="canSeePhotoSearch">
      <CSidebarNavItem
          :class="['border-top', 'mt-2', 'pt-1']"
          :name="$gettext('Browse Photos')"
          :to="{name: 'photoSearch.search', params: {picaServiceId: picaServiceId}}"
          icon="cip-search"
      />
    </template>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import draggable from 'vuedraggable'
import SubGalleryNav from './SubGalleryNav.vue'

export default {
  name: 'GalleryNav',
  emits: ['createGallery'],
  components: {
    draggable,
    SubGalleryNav,
  },
  data() {
    return {
      sortedGalleries: []
    }
  },
  watch: {
    galleries: {
      handler() {
        this.sortedGalleries = this.galleries
      },
      deep: true
    }
  },
  mounted() {
    this.sortedGalleries = this.galleries
  },
  computed: {
    ...mapGetters('eventWizard', [
      'canSeePhotoSearch'
    ]),
    ...mapGetters('event', [
      'picaServiceId',
    ]),
    ...mapGetters('eventGallery', [
      'galleries',
    ]),
    ...mapGetters('uploader', [
      'hasGlobalProcessingMedia'
    ]),
    canSort() {
      return this.hasPerm('gallery.sort')
    },
    canSeeGallery() {
      return this.galleries.length > 0 || this.hasPerm('gallery.create')
    },
    tab() {
      let route = this.$route.matched.find(m => m.props?.default?.tab)
      if (route) return route.props.default.tab
      return "detail"
    },
  },
  methods: {
    ...mapActions('eventGallery', [
      'updateSorting',
      'updateSubSorting'
    ]),
    updateGallerySorting() {
      this.updateSorting(this.sortedGalleries.map(gallery => gallery.id))
    },
    handleSubSorting(data) {
      this.updateSubSorting(data)
    }
  }
}
</script>
